<template>
  <div class="signin">
    <Authenticator> </Authenticator>
  </div>
</template>

<style lang="less" scoped>
@import "../assets/styles/variables";

.signin {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
